export default __webpack_public_path__ + "static/media/guy-with-headphones.bbd3ecb0.png";